import Vue from 'vue';

const state = Vue.observable({
  paginas: [],
});

export function getState() {
  return state;
}

// Salve o estado no localStorage antes de atualizar a página
window.addEventListener('beforeunload', () => {
  localStorage.setItem('paginas', JSON.stringify(state.paginas));
});

// Carregue o estado do localStorage quando a aplicação é inicializada
if (localStorage.getItem('paginas')) {
  state.paginas = JSON.parse(localStorage.getItem('paginas'));
}
